import { formatPrice, shipperHasWriteAccess } from "utils";

import type { PendingOffPlatformBooking } from "hooks";

/*
The endpoint rejects an ineligible shipment type or status regardless of what the
client sends; this gate only keeps the entry points from appearing. QUOTES_ONLY can
not be booked at all and a project child is booked through load assignment, so
neither can carry an off-platform booking.
*/
export function isEligibleForOffPlatformBooking(
  shipment: ShipperCondensedShipment,
): boolean {
  return (
    shipment.shipment_status === "ACTIVE" &&
    shipperHasWriteAccess(shipment.access_type) &&
    shipment.info.type !== "QUOTES_ONLY" &&
    shipment.info.type !== "MULTI_SHIPMENT_PROJECT_CHILD"
  );
}

export function formatPendingOffPlatformBookingRate(
  pendingOffPlatformBooking: PendingOffPlatformBooking,
): string {
  return formatPrice(
    pendingOffPlatformBooking.price,
    pendingOffPlatformBooking.currency,
    pendingOffPlatformBooking.quoting_unit_of_measure,
  );
}

// loads_booked is only set on a MULTI_SHIPMENT_PROJECT report.
export function formatPendingOffPlatformBookingAmount(
  pendingOffPlatformBooking: PendingOffPlatformBooking,
): string {
  const rate = formatPendingOffPlatformBookingRate(pendingOffPlatformBooking);
  const loadsBooked = pendingOffPlatformBooking.loads_booked;
  if (loadsBooked === null) {
    return rate;
  }
  return `${loadsBooked} ${loadsBooked === 1 ? "load" : "loads"} at ${rate}`;
}

export function formatPendingOffPlatformBookingCarrier(
  pendingOffPlatformBooking: PendingOffPlatformBooking,
): string {
  return (
    pendingOffPlatformBooking.carrier_company_name ??
    pendingOffPlatformBooking.carrier_email ??
    ""
  );
}
